<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Onlayn tərcümə servisi (müvəqqəti olaraq işləmir)</h1>
      </div>
      <div class="col-md-6">
        <p class="d-flex justify-content-between">
          Mətn hansı dildədi: 
          <span class="change-lang" @click="changeLang">&harr;</span>
        </p>
        <select v-model="langFrom">
          <option :value="lang.code" v-for="lang in languages">{{ lang.name }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <p>Hansı dilə tərcümə olunmalıdı:</p>
        <select v-model="langTo">
          <option :value="lang.code" v-for="lang in languages">{{ lang.name }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <textarea rows="6" v-model="text" @input="checkText"></textarea>
        <small :class="{ danger: isDanger }">{{ text.length }}</small>
      </div>
      <div class="col-md-6">
        <textarea rows="6" v-text="out" disabled></textarea>
        <small>{{ status }}</small>
      </div>
      <div class="col-12">
        <input type="submit" value="Tərcümə et" @click="translate" :disabled="isDisabled">
      </div>
      <div class="col-12">
        <p>{{ error }}</p>
      </div>
      <div class="col-12">
        <p class="note link">Translated by <a href="https://translate.yandex.com/">Yandex.Translate</a></p>
      </div>
    </div>
  </div>
  
</template>

<script>

  import axios from 'axios';

  export default {
    data(){
      return {
        languages: [
          {'name':'Azərbaycan','code':'az'},
          {'name':'Alban','code':'sq'},
          {'name':'İngilis','code':'en'},
          {'name':'Ərəb','code':'ar'},
          {'name':'Erməni','code':'hy'},
          {'name':'Başqırd','code':'ba'},
          {'name':'Belarus','code':'be'},
          {'name':'Benqalski','code':'bn'},
          {'name':'Birman','code':'my'},
          {'name':'Bolqar','code':'bg'},
          {'name':'Bosniya','code':'bs'},
          {'name':'Uels','code':'cy'},
          {'name':'Macar','code':'hu'},
          {'name':'Vyetnam','code':'vi'},
          {'name':'Haiti kreol','code':'ht'},
          {'name':'Qalisian','code':'gl'},
          {'name':'Holland','code':'nl'},
          {'name':'Dağlıq Maric','code':'mrj'},
          {'name':'Yunan','code':'el'},
          {'name':'Gürcü','code':'ka'},
          {'name':'Qucarat','code':'gu'},
          {'name':'Danimarka','code':'da'},
          {'name':'İvrit','code':'he'},
          {'name':'İdiş','code':'yi'},
          {'name':'İndoneziya','code':'id'},
          {'name':'İrlandiya','code':'ga'},
          {'name':'İtalyan','code':'it'},
          {'name':'İslandiya','code':'is'},
          {'name':'İspan','code':'es'},
          {'name':'Qazax','code':'kk'},
          {'name':'Kannada','code':'kn'},
          {'name':'Katalan','code':'ca'},
          {'name':'Qırğız','code':'ky'},
          {'name':'Çin','code':'zh'},
          {'name':'Koreya','code':'ko'},
          {'name':'Kosa','code':'xh'},
          {'name':'Kxmer','code':'km'},
          {'name':'Laos','code':'lo'},
          {'name':'Latın','code':'la'},
          {'name':'Latış','code':'lv'},
          {'name':'Litva','code':'lt'},
          {'name':'Lüksemburq','code':'lb'},
          {'name':'Malagas','code':'mg'},
          {'name':'Malay','code':'ms'},
          {'name':'Malayalam','code':'ml'},
          {'name':'Malta','code':'mt'},
          {'name':'Makedoniyalı','code':'mk'},
          {'name':'Maori','code':'mi'},
          {'name':'Marathi','code':'mr'},
          {'name':'Mari','code':'mhr'},
          {'name':'Monqol','code':'mn'},
          {'name':'Alman','code':'de'},
          {'name':'Nepal','code':'ne'},
          {'name':'Norveç','code':'no'},
          {'name':'Pencab','code':'pa'},
          {'name':'Papiamento','code':'pap'},
          {'name':'Fars','code':'fa'},
          {'name':'Polşa','code':'pl'},
          {'name':'Portuqaliya','code':'pt'},
          {'name':'Rumıniya','code':'ro'},
          {'name':'Rus','code':'ru'},
          {'name':'Cebuan','code':'ceb'},
          {'name':'Serbiya','code':'sr'},
          {'name':'Singal','code':'si'},
          {'name':'Slovakiya','code':'sk'},
          {'name':'Sloveniya','code':'sl'},
          {'name':'Suaxili','code':'sw'},
          {'name':'Sundan','code':'su'},
          {'name':'Tacik','code':'tg'},
          {'name':'Tailand','code':'th'},
          {'name':'Tagal','code':'tl'},
          {'name':'Tamil','code':'ta'},
          {'name':'Tatar','code':'tt'},
          {'name':'Telugu','code':'te'},
          {'name':'Türk','code':'tr'},
          {'name':'Udmurt','code':'udm'},
          {'name':'Özbək','code':'uz'},
          {'name':'Ukrayna','code':'uk'},
          {'name':'Urdu','code':'ur'},
          {'name':'Finlandiya','code':'fi'},
          {'name':'Fransa','code':'fr'},
          {'name':'Hindi','code':'hi'},
          {'name':'Xorvatiya','code':'hr'},
          {'name':'Çexiya','code':'cs'},
          {'name':'İsveç','code':'sv'},
          {'name':'Şotlandiya','code':'gd'},
          {'name':'Estoniya','code':'et'},
          {'name':'Esperanto','code':'eo'},
          {'name':'Yava','code':'jv'},
          {'name':'Yapon','code':'ja'}
        ],
        url: 'https://translate.yandex.net/api/v1.5/tr.json/translate?key=trnsl.1.1.20190226T112918Z.2e23b879586da99f.a99764a3ecb245193b1a72e81526365481b28576',
        text: '',
        out: '',
        langFrom: 'az',
        langTo: 'ru',
        error: '',
        status: '',
        isDanger: true,
        isDisabled: true
      }
    },
    methods: {
      changeLang: function(){
        let from = this.langFrom;
        let to = this.langTo;
        this.langFrom = to;
        this.langTo = from;
      },
      translate: function(){

        this.isDisabled = true;
        this.status = 'Tərcümə olunur...';

        let text = encodeURIComponent(this.text);
        let url = this.url + '&text=' + text + '&lang=' + this.langFrom + '-' + this.langTo;

        axios.get(url)
        .then(response => {
          this.status = '';
          this.isDisabled = false;
          this.out = response.data.text[0];
        })
        .catch(error => {
          console.log(error);
        });

      },
      checkText: function(){
        if(this.text.length > 300 || this.text.length < 2){
          this.isDanger = true;
          this.isDisabled = true;
          this.error = 'Mətnin uzunluğu 2 - 300 simvol arası olmalıdı.';
        } else {
          this.isDanger = false;
          this.isDisabled = false;
          this.error = '';
        }
      }
    }
  }
</script>

<style scoped>
  .danger {
    color: red;
  }
  select {
    margin-bottom: 1rem;
  }
  textarea {
    line-height: 1.5rem;
  }
  input[type="submit"] {
    transition: all 0.3s ease;
  }
  input[type="submit"]:disabled {
    background: #CCC;
  }
  .change-lang {
    cursor: pointer;
    display: block;
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1rem;
    color: #003366;
  }
  p.link {
    text-align: right;
  }
  p.link a {
    color: #333;
    text-decoration: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/calc/Translate.vue